import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {
  SelectInput,
  SelectInputProps,
} from 'up-ops-web-shared-components/lib/components/inputs/select-input';

import { FormComponentProps } from 'types/components';

type FormSelectInputProps = SelectInputProps & FormComponentProps;

const FormSelectInput = ({
  defaultValue,
  name,
  rules,
  ...otherProps
}: FormSelectInputProps) => {
  const { control, formState } = useFormContext();
  const fieldName = `${name}` as const;

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={fieldName}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, ref, value } = field;
        const { error, invalid } = fieldState;
        return (
          <SelectInput
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            innerRef={ref}
            onBlur={onBlur}
            onChange={onChange}
            value={value}
            {...otherProps}
          />
        );
      }}
      rules={rules}
    />
  );
};

export default FormSelectInput;
